import { Component, Inject, HostListener } from '@angular/core';
import { EventsServiceInterface } from '../../services/events/events.interface';
import { IConfigurationService } from '../../services/configuration/configuration-service.interface';
import { DOCUMENT } from '@angular/common';
import { ISidebarService } from '../../services/sidebar/sidebar.interface';
import { BrowserWindowRef } from '../../services/window/window.service';
import { IApplicationsService } from '../../services/applications/applications.interfaces';
import { IApplication } from '@platform500services/p500-ui-kit';
import { take } from 'rxjs/operators';
import { IAlert, IAlertService } from '../notifications-menu/services/alerts/alert.interfaces';
import { getLatestDate } from '../notifications-menu/services/alerts/alert.helpers';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';
import { notificationPermissions } from '../notifications-sidebar/notification.helper';
import { getSettingsContent } from '../../../modules/settings/settings/settings-page/settings-page.content';
import { IDataService, IParsedDataResponse } from '../../services/data/data-service.interface';
import { GTD_BROADCAST_EVENTS } from '../../services/events/broadcast-event.interface';
import { IEnvironmentService } from '../../services/environment/environment.interface';

@Component({
  selector: 'gtd-nav-panel',
  templateUrl: './nav-panel.component.html',
})
@DestroySubscribers()
export class NavPanelComponent {
  public applicationsAmount = 0;
  public applications: IApplication[];
  public isAlertRead = true;
  public isCriticalAlert = false;
  private subscribers: any = {};
  public isDangerAlert = false;
  public latestAlertDate: number;
  public RbacPermissionsConstant = RbacPermissionsConstant;
  public partOfLink: string;
  public notifications = false;
  public isNotificationsOpen = false;
  public settingsAccess = false;
  public globalData: IParsedDataResponse;
  public chatIsOpen = false;
  public hasUnreadMessage = false;
  public frontAppChatId = '';

  constructor(
    @Inject('EventsServiceInterface') private eventsService: EventsServiceInterface,
    @Inject('IConfigurationService') public configurationService: IConfigurationService,
    @Inject(DOCUMENT) private dom: Document,
    @Inject(BrowserWindowRef) private window: BrowserWindowRef,
    @Inject('ISidebarService') public sidebarService: ISidebarService,
    @Inject('IApplicationsService') private applicationsService: IApplicationsService,
    @Inject('IAlertService') private alertService: IAlertService,
    @Inject('RbacServiceInterface') public rbacService: RbacServiceInterface,
    @Inject('IDataService') private dataService: IDataService,
    @Inject('IEnvironmentService') private envService: IEnvironmentService
  ) {
    this.globalData = this.dataService.getData();

    notificationPermissions.forEach((permission) => {
      if (rbacService.can(permission)) {
        this.notifications = true;
      }
    });

    if (rbacService.can(RbacPermissionsConstant.PAGES_TABLE_NOTIFICATIONS)) {
      this.subscribers.alertStatus = this.alertService.getAlerts().subscribe((alerts: IAlert[]) => {
        this.isCriticalAlert = alerts.some((alert) => alert.type === ' Error');
        this.isDangerAlert = alerts.some((alert) => alert.type === 'Danger' || alert.type === 'Critical');
        this.latestAlertDate = getLatestDate(alerts);
      });
    }
    this.applicationsService
      .getData()
      .pipe(take(1))
      .subscribe((data) => {
        this.applicationsAmount = data.length;
        this.applications = data;
      });
    this.partOfLink = (configurationService.data().brand.masterDomain.match(/[^id].+/) + '').toString();
    this.eventsService.on('isOpenNotificationsSidebar:toggle').subscribe(() => {
      this.isNotificationsOpen = !this.isNotificationsOpen;
    });
    this.settingsAccess = Object.values(getSettingsContent(rbacService)).some((values) => values?.length);
    this.eventsService.on(GTD_BROADCAST_EVENTS.FRONT_CHAT_INIT).subscribe(() => {
      this.window.nativeWindow.FrontChat('onUnreadChange', (unreadChanges: { unread_count: number; source: 'user' | 'chatbot' }) => {
        if (unreadChanges.source === 'chatbot') {
          return;
        }
        this.hasUnreadMessage = unreadChanges.unread_count > 0;
      });
      this.window.nativeWindow.FrontChat('onWindowVisibilityChanged', (visibleChanges: { is_window_visible: boolean }) => {
        this.chatIsOpen = visibleChanges.is_window_visible;
      });
    });
    this.frontAppChatId = this.envService.getVar('frontappChatId') as string;
  }

  @HostListener('document:click', ['$event'])
  @HostListener('document:touch', ['$event'])
  handleOutsideClick(event) {
    if (this.sidebarService.getMenuSection() === 'menu' || this.window.nativeWindow.innerWidth < 768) {
      return;
    }
    const popups = Array.from(this.dom.querySelectorAll('.c-menu-list'));
    if (!popups.some((popup) => popup.contains(event.target))) {
      this.sidebarService.setMenuSection('menu');
    }
  }

  openCrmSwitchModal(): void {
    this.eventsService.broadcast('isOpenSelector:toggle');
  }

  openMenuSection(buttonName: string): void {
    setTimeout(() => {
      this.sidebarService.setMenuSection(buttonName);
    }, 0);
  }

  closeSidebar(): void {
    this.eventsService.broadcast('sidebarComponent:toggle');
  }

  openNotificationsMenu(date: number): void {
    this.alertService.updateReadStatus(date);
    this.eventsService.broadcast('isOpenNotificationsSidebar:toggle');
  }

  openSupportChat(): void {
    this.openMenuSection('support');
    this.window.nativeWindow.FrontChat(this.chatIsOpen ? 'hide' : 'show');
    this.chatIsOpen = !this.chatIsOpen;
    this.hasUnreadMessage = false;
  }
}
